import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWhiteboard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconWhiteboard2"><Path d="M12.5 3.5C12.5 3.22386 12.2761 3 12 3C11.7239 3 11.5 3.22386 11.5 3.5V4H2.5C2.22386 4 2 4.22386 2 4.5C2 4.77614 2.22386 5 2.5 5H3V19H2.5C2.22386 19 2 19.2239 2 19.5C2 19.7761 2.22386 20 2.5 20H21.5C21.7761 20 22 19.7761 22 19.5C22 19.2239 21.7761 19 21.5 19H21V5H21.5C21.7761 5 22 4.77614 22 4.5C22 4.22386 21.7761 4 21.5 4H12.5V3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWhiteboard2;
